import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/helpdesk/index.css';

// Prevent 3rd-party third-party SDK errors (e.g. Genesys PureCloud) from triggering the CRA dev error overlay
if (process.env.NODE_ENV === 'development') {
  window.addEventListener(
    'error',
    (event: ErrorEvent) => {
      if (
        event.message === 'Script error.' ||
        (event.filename && !event.filename.includes('localhost') && !event.filename.includes('127.0.0.1'))
      ) {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  window.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      if (
        reason &&
        typeof reason.stack === 'string' &&
        (reason.stack.includes('mypurecloud') || reason.stack.includes('genesys'))
      ) {
        event.stopImmediatePropagation();
      }
    },
    true
  );
}

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
